// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CityVehicleCmp from "../reusable-components/CityVehicleCmp.bs.js";
import * as SidebarHeaderCmp from "../reusable-components/SidebarHeaderCmp.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as RoundedPrimaryButton$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/RoundedPrimaryButton.bs.js";

function CreateCampaignContainer(Props) {
  var vehicle = Props.vehicle;
  var geo_region = Props.geo_region;
  var campaigns_list = Props.campaigns_list;
  var dispatch = Props.dispatch;
  console.log(campaigns_list, dispatch, vehicle, geo_region);
  return React.createElement("div", {
              className: "c-create-campaign-container"
            }, React.createElement("div", {
                  className: "body"
                }, React.createElement(SidebarHeaderCmp.make, {
                      preview: true,
                      campaign_name: undefined,
                      discard_warning_required: false,
                      dispatch: dispatch
                    }), React.createElement(CityVehicleCmp.make, {
                      vehicle_name: vehicle.vehicle.vehicle_type,
                      geo_region: geo_region.name
                    }), React.createElement("div", {
                      className: "create-campaign-btn-wrapper"
                    }, React.createElement(RoundedPrimaryButton$Catalyst.make, {
                          buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                TAG: /* Custom */1,
                                _0: (function (param) {
                                    return React.createElement("p", {
                                                className: "create-campaign-btn-text"
                                              }, "Update Mandatory Campaign");
                                  })
                              }, undefined, (function (param) {
                                  return Curry._1(dispatch, {
                                              TAG: /* UpdateSidebarState */6,
                                              opened_sidebar: /* CreateMandatoryCampaign */1
                                            });
                                }), undefined, undefined, undefined, undefined, "create-campaign-btn", undefined, undefined)
                        }), React.createElement(RoundedPrimaryButton$Catalyst.make, {
                          buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                TAG: /* Custom */1,
                                _0: (function (param) {
                                    return React.createElement("p", {
                                                className: "create-campaign-btn-text"
                                              }, "Add Zone/ Cluster Campaign");
                                  })
                              }, undefined, (function (param) {
                                  return Curry._1(dispatch, {
                                              TAG: /* UpdateSidebarState */6,
                                              opened_sidebar: /* CreateZonalOrClusterCampaign */2
                                            });
                                }), undefined, undefined, undefined, undefined, "create-campaign-btn", undefined, undefined)
                        }))));
}

var make = CreateCampaignContainer;

export {
  make ,
  
}
/* react Not a pure module */
